import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useCallback } from "react";
import ee from "../../../../services/EventEmitter";
import { ENABLE_UPDATE_CMR_FORM } from "../../../../constants/events";
import Authorize from "../../../Authorize";
import { CAN_CREATE_AND_EDIT_CMR } from "../../../../constants/authorize";

interface Props {
  id: number;
}

const Edit: React.FC<Props> = ({ id }) => {
  const onClickHandler = useCallback(() => {
    ee.emit(ENABLE_UPDATE_CMR_FORM, id);
  }, [id]);

  return (
    <Authorize permission={[CAN_CREATE_AND_EDIT_CMR]}>
      <Button type="primary" onClick={onClickHandler}>
        <EditOutlined />
      </Button>
    </Authorize>
  );
};

export default Edit;
